import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import { DOWNLOAD_SIMPLE } from '../../../../../../constants/images';
import {
  CLICK_ACTION,
  DOWNLOAD_REPORT,
  ERROR_ACTION,
  SECTION_METRICS_V3,
  SUB_SECTION_MONTHLY_REPORTS
} from '../../../../../../constants/tagManager';
import { CompanyContext } from '../../../../../../context/company/companyContext';
import { useMonthlyReportDownload } from '../../../../../../hooks/useMonthlyReport/useMonthlyReport';
import { TRANSLATIONS_GLOBAL } from '../../../../../../translations/commons';
import { TRANSLATIONS_REPORTS } from '../../../../../../translations/reports';
import BdsTooltip from '../../../../BdsTooltip/BdsTooltip';
import BdsIconButton from '../../../../Buttons/BdsIconButton/BdsIconButton';
import LoadingModal from '../../../../Modals/LoadingModal/LoadingModal';
import Toast from '../../../../Toast/Toast';

interface IMonthlyReportsTableActionsProps {
  period: string;
  disabled?: boolean;
}

export const MonthlyReportsTableActions = ({ period, disabled }: IMonthlyReportsTableActionsProps) => {
  const { company, isSpain } = useContext(CompanyContext);
  const loadingText = isSpain ? TRANSLATIONS_REPORTS.rf.loadingModal : TRANSLATIONS_REPORTS.default.loadingModal;

  const { t } = useTranslation();

  const { loading, showToast, toastData, downloadMonthlyReport, closeToast } = useMonthlyReportDownload({
    tagManagerData: {
      clickEvent: CLICK_ACTION,
      successEvent: DOWNLOAD_REPORT,
      errorEvent: ERROR_ACTION,
      gtmParams: {
        ...SECTION_METRICS_V3,
        ...SUB_SECTION_MONTHLY_REPORTS
      }
    },
    companyId: company.id,
    date: period
  });

  const renderIconButton = () => (
    <BdsIconButton
      icon={DOWNLOAD_SIMPLE}
      variant="transparent"
      size="sm"
      action={downloadMonthlyReport}
      className="reports-table-actions__button"
      aria-label={t(TRANSLATIONS_GLOBAL.downloadMonthlyReport.button)}
      disabled={disabled}
    />
  );

  return (
    <>
      {disabled ? (
        <BdsTooltip message={t(TRANSLATIONS_REPORTS.table.tooltip)} position="left" className="text-start">
          {renderIconButton()}
        </BdsTooltip>
      ) : (
        renderIconButton()
      )}
      <LoadingModal showModal={loading} description={t(loadingText)} />
      <Toast
        title={t(toastData.title)}
        description={t(toastData.description)}
        icon={toastData.icon}
        open={showToast}
        button={toastData.button}
        handleClose={closeToast}
      />
    </>
  );
};

export default MonthlyReportsTableActions;
